// Recovered compiled webpack factory 80486. Edit this function expression; run npm run build.
(e, t, n) => {
  "use strict";
  n.d(t, {
    $W: () =>
      function e(t) {
        let n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
        return (
          !(n > 6) &&
          (!!(function (e) {
            if (!e || "object" != typeof e) return !1;
            if (
              e.digest === o ||
              "DbUnavailableError" === e.name ||
              ("string" == typeof e.code && (i.has(e.code) || a.has(e.code) || s.has(e.code))) ||
              "TimeoutError" === e.name
            )
              return !0;
            if ("string" == typeof e.message) {
              if (c.test(e.message)) return !1;
              if (d.some((t) => t.test(e.message))) return !0;
            }
            return !1;
          })(t) ||
            (!!t &&
              "object" == typeof t &&
              (!!(void 0 !== t.cause && t.cause !== t && e(t.cause, n + 1)) ||
                (!!Array.isArray(t.errors) && t.errors.some((r) => r !== t && e(r, n + 1))))))
        );
      },
    BB: () => l,
    fY: () => o,
    yv: () => r,
  });
  let r = "Database is not responding, try again later.",
    o = "DB_UNAVAILABLE",
    i = new Set(["P1001", "P1002", "P1008", "P1017", "P2024", "P2028"]),
    a = new Set([
      "HRANA_WEBSOCKET_ERROR",
      "HRANA_CLOSED_ERROR",
      "SERVER_ERROR",
      "WEBSOCKETS_NOT_SUPPORTED",
    ]),
    s = new Set([
      "ECONNREFUSED",
      "ECONNRESET",
      "ETIMEDOUT",
      "ENOTFOUND",
      "EAI_AGAIN",
      "EPIPE",
      "UND_ERR_CONNECT_TIMEOUT",
      "UND_ERR_HEADERS_TIMEOUT",
      "UND_ERR_SOCKET",
    ]),
    d = [
      /connections? limit exceeded/i,
      /try to reduce concurrency/i,
      /unable to start a transaction in the given time/i,
      /transaction (api error: )?(already closed|not found)/i,
      /operation was aborted due to timeout/i,
      /\bfetch failed\b/i,
      /socket hang up/i,
      /server returned http status 5\d\d/i,
      /websocket (was closed|is not open|connection (failed|closed))/i,
      /\b(ECONNREFUSED|ECONNRESET|ETIMEDOUT|ENOTFOUND|EAI_AGAIN)\b/,
      /database is unavailable|server is (temporarily )?unavailable|service unavailable/i,
    ],
    c = /SQLITE_BUSY|SQLITE_LOCKED|database is locked/i;
  function l(e) {
    return !!e && "object" == typeof e && "database-unavailable" === e.error;
  }
}
